var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 40,
    fill: "url(#pattern0_101_1958)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_101_1958",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_101_1958",
    transform: "matrix(0.0114286 0 0 0.01 -0.0714286 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_101_1958",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA7JJREFUeAHtnSGM1EAUhpeEEAgCgUVhwCBRILFILEFhybw32826GhIsEovEIrFIDCQIBGgsCckFQY4d6IQRd9N22m7fe/Nfctm7m04z8333pve33d5mgw8QAAEQAAEQAAEQAAEQAAEQAAEQAAEQAAEQMEJgu93e895fNTId/dPw3r9h5h9E9LJpmhv6Z6R8Bp2QU2Y+JaJf3fd3lU9L7/BTIUFK/CSi9977h5vN5oLe2Skc+XlCohhm/sLMz9q2vaxwevqGPEBIrJrv3vt2v99f1zdLRSMeISQeZ06cc6+Z+baiaeoZ6lghcSkjot/M/NZ7/0DPbBWMtFRIFNO9fiCix23bXlQwZdlDnElIXM6+ee93u93umuxZCx7dnEKSqkHQLHW+kJBYMQiaY8UsKSSpmHAWAEFziJxjCUnkIGjmxKwgBEFTqJB4nEHQTAWtWCGxUqIYBM0gRoqQ5BgTBNUbNIUKiVVTX9CULCSpmnqCphIhsWLsB01NQpKKsRs0tQpJ5NgKmgaE/F3OmNnGFU1DQuJxRnfQtCYkLmVqr2haFRLFdK96gmYlQuJyJj9o1iQkqRq5QbNSIbFi5AXNmoUkFSMnaDLzc2b+SkQn6QAr/voTET1p2/ZSeplila+dc1cOdyXeZOb7RPQo3NNLRC+6OxXfHX72Obx1oRJZeoJmTeLCymHm1llL4tQGzZK1VqE4PUGzRMjQPtLEHe5nlh80h8JdcrsVxMkNmkuCHrpvCBlKauJ2K4CO11rOfA1LVogG5t5WLg30gJyl86CuEPSZlRAExT97w4MWJhb6/N0tge6rBiL6ycyvmqa5NT/Jnj3WBLpPxGrX6HFy8f/DEjpJ655cxOn3f0LEvKGoZiHh2S7hxKFz7k7Pan685kqFyE3WNQlREeQqEaInyFkVIjrI5Y5I1oSsGuRyoIe2GRKi5xp4To52Ic65j8z81MwD1rQKERPkcr/tJW2ahIgMciXQc32UCJEb5HJwS9okC1ER5Eqg5/oIFaInyOXglrRJEaI2yJVAz/VZW4j6IJeDW9K2ohAbQa4Eeq7PsYWYC3I5uCVtxxJiNsiVQM/1WVJIFUEuB7ekbSEh9QS5Eui5PnMKqTLI5eCWtM0kpN4gVwI916dUCIJcjuqEtrFCEOQmwB7SdYQQBLkhQKdu0ycEQW4q4ZH9zxOCIDcS5Fybp0IQ5OaiOmE/nRAEuQkMZ+2Kf706K07sDARAAARAAARAAARAAARAAARAAARAAARAAATMEPgDJMEMziyyFVIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3352523bb97878585bbe0738c3483440.svg";
export { ForwardRef as ReactComponent };